import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GetFormBuilderFieldsListDto } from 'src/app/core/api/models';
import { UpdateFormBuilderEntityFieldRequest } from 'src/app/core/api/models/update-form-builder-entity-field-request';
import { BaseFormModule } from 'src/app/pages/shared/base';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';
import { FieldsManagementFormComponent } from '../../fields-management/fields-management-form/fields-management-form.component';
import { FieldsComponent } from '../forms-management-form/fields/fields.component';

@Component({
  selector: 'create-field-dialog',
  templateUrl: './create-field-dialog.component.html',
  imports: [
    BaseFormModule,
    ModalTitleComponent,
    FieldsComponent,
  ],
})
export class CreateFieldDialogComponent {
  loading: boolean = false;
  fieldData: UpdateFormBuilderEntityFieldRequest = {};
  formBuilderFieldsList: Array<GetFormBuilderFieldsListDto> | null;
  fields: any;

  constructor(
    private dialogRef: MatDialogRef<CreateFieldDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formBuilderFieldsList = this.data?.formBuilderFieldsList;
    this.fields = data?.fields;
  }

  ngOnInit(): void {
    const idsToRemoveFromFieldsList = this.fields?.map(
      (obj) => obj.formBuilderFieldId
    );

    this.formBuilderFieldsList = this.formBuilderFieldsList?.filter(
      (item) => !idsToRemoveFromFieldsList.includes(item.id)
    );
  }

  setFields(event) {
    this.fieldData = event;
  }

  onClose() {
    this.dialogRef.close();
  }

  onSubmit() {
    this.dialogRef.close(this.fieldData);
  }
}
